// Dergi yazıları (BrandMap)
// Content stored inline; each paragraph as a separate string for clean rendering.

import {
  type ArticleMeta,
  articlesMeta,
  getArticleMeta,
  getArticleLang,
  articlesByLang,
  homepageArticles,
  HOMEPAGE_SLUGS,
} from "./articles-meta";
import type { ArticleBodyBlock } from "./articles-bodies";

export type Article = ArticleMeta & { body: ArticleBodyBlock[] };

export {
  articlesMeta as articles,
  getArticleMeta,
  getArticleLang,
  articlesByLang,
  homepageArticles,
  HOMEPAGE_SLUGS,
};

export async function getArticle(slug: string): Promise<Article | undefined> {
  const meta = getArticleMeta(slug);
  if (!meta) return undefined;
  const { ARTICLE_BODIES } = await import("./articles-bodies");
  const body = ARTICLE_BODIES[slug];
  if (!body) return undefined;
  return { ...meta, body };
}
